type UseIsAskMeAnythingEnabled = () => boolean;
export const useIsAskMeAnythingEnabled: UseIsAskMeAnythingEnabled = () => true;
